import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useAuth } from '../../AuthenticatedApp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faKey, faSpinner, faShieldAlt, faUserCog } from '@fortawesome/free-solid-svg-icons';
import AdminPageHeader from '../shared/AdminPageHeader';
import AdminNotice from '../shared/AdminNotice';
import AdminSectionCard from '../shared/AdminSectionCard';
import LoadingSpinner from '../LoadingSpinner';
import '../../styles/route_pages/Profile.css';
import { sendPasswordResetEmail } from '../../utils/authService';

const Profile = () => {
  const { user, getAccessTokenSilently } = useAuth0();
  const { userRole } = useAuth();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSendPasswordResetEmail = async () => {
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      await sendPasswordResetEmail(user.email, getAccessTokenSilently);
      setSuccess(true);
    } catch (requestError) {
      console.error('Failed to send password reset email:', requestError);
      setError(requestError.message || 'Şifre sıfırlama e-postası gönderilemedi');
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return <LoadingSpinner />;
  }

  return (
    <div className="page-container">
      <AdminPageHeader
        title="Profil Ayarları"
        subtitle="Hesap bilgilerinizi görüntüleyin ve güvenlik aksiyonlarını daha net bir yönetim yüzeyinden yönetin."
      />

      {success ? (
        <AdminNotice
          tone="success"
          title="Şifre sıfırlama e-postası gönderildi"
          message={`${user.email} adresine güvenli şifre sıfırlama bağlantısı gönderildi.`}
          onDismiss={() => setSuccess(false)}
          autoDismissMs={5000}
        />
      ) : null}

      {error ? <AdminNotice tone="error" title="İşlem tamamlanamadı" message={error} onDismiss={() => setError('')} /> : null}

      <div className="profile-sections-grid">
        <AdminSectionCard title="Hesap Özeti" subtitle="Oturum hesabınız ve temel erişim bağlamınız burada özetlenir.">
          <div className="profile-summary-card">
            <div className="admin-symbol-token profile-avatar-token">
              <FontAwesomeIcon icon={faUser} />
            </div>
            <div>
              <h2 className="profile-summary-title">{user.name || user.email}</h2>
              <p className="profile-summary-subtitle">Garcon yönetim paneli hesabı</p>
              <div className="admin-chip-row">
                <span className="admin-chip admin-chip-accent">
                  <FontAwesomeIcon icon={faUserCog} />
                  {userRole?.name || 'Rol bilgisi yok'}
                </span>
              </div>
            </div>
          </div>
          <div className="admin-detail-grid profile-detail-grid">
            <div className="admin-detail-card">
              <div className="admin-detail-card-title">İletişim</div>
              <div className="admin-detail-list">
                <div className="admin-detail-item">
                  <div className="admin-detail-label">
                    <FontAwesomeIcon icon={faEnvelope} /> E-posta
                  </div>
                  <div className="admin-detail-value">{user.email}</div>
                </div>
              </div>
            </div>
            <div className="admin-detail-card">
              <div className="admin-detail-card-title">Yetki</div>
              <div className="admin-detail-list">
                <div className="admin-detail-item">
                  <div className="admin-detail-label">
                    <FontAwesomeIcon icon={faUserCog} /> Rol
                  </div>
                  <div className="admin-detail-value">{userRole?.name || 'Rol bilgisi yok'}</div>
                </div>
              </div>
            </div>
          </div>
        </AdminSectionCard>

        <AdminSectionCard title="Güvenlik" subtitle="Şifre sıfırlama gibi hesap güvenliği aksiyonlarını buradan yönetin.">
          <div className="profile-security-intro">
            <div className="admin-chip admin-chip-warning">
              <FontAwesomeIcon icon={faShieldAlt} />
              E-posta ile güvenli şifre sıfırlama
            </div>
            <p className="admin-muted-note">
              Şifrenizi değiştirmek için e-posta adresinize tek kullanımlık bir bağlantı gönderebiliriz. Bağlantı üzerinden yeni bir parola belirlenir.
            </p>
          </div>
          <div className="profile-security-actions">
            <button className="btn btn-primary profile-reset-button" onClick={handleSendPasswordResetEmail} disabled={loading}>
              <FontAwesomeIcon icon={loading ? faSpinner : faKey} className={loading ? 'fa-spin' : ''} />
              {loading ? 'Gönderiliyor...' : 'Şifre Sıfırlama E-postası Gönder'}
            </button>
          </div>
        </AdminSectionCard>
      </div>
    </div>
  );
};

export default Profile;
